/**
 * The workspace switcher's words, shared by today's pill (src/components/WorkspacePill.tsx) and the new design's app
 * header (design-system §7b rule 1: the words are one list, so the two can never say different things).
 */
export const WORKSPACE_PILL_WORDS = {
  /** Marks a workspace this person owns (founded it or was made its owner later). */
  yours: 'yours',
  /** The pill before this tab's workspace is known: honest, never a guess (INCIDENT-20260818). */
  resolving: 'resolving workspace…',
  pillLabel: (label: string) => `Workspace: ${label}. Open switcher.`,
  pillLabelResolving: 'Workspace resolving. Open switcher.',
  menuLabel: 'Switch workspace',
  switching: 'switching…',
  settingUp: 'setting up…',
  current: '✓ current',
  setUp: 'set up',
  member: 'member',
  setAside: (label: string) => `set aside ${label}`,
  settingAside: 'setting aside…',
  nothingDeleted: 'nothing is deleted',
  newOrganization: '+ start a new organization',
  /** The new design's phone sheet: the title over the workspace rows. */
  sheetTitle: 'workspace',
} as const;
